import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=12472771&scoped=true"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=12472771&prod&scoped=true&lang=scss"
import style1 from "./EditUser.vue?vue&type=style&index=1&id=12472771&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12472771",
  null
  
)

export default component.exports